import { CHCValuePropHeading } from "./value-prop-heading.component.js";
customElements.define("chc-value-prop-heading", CHCValuePropHeading);
export {
  CHCValuePropHeading
};
//# sourceMappingURL=value-prop-heading.js.map
